import { FlagOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface CommentButtonProps {
  setIsCommentModal(value: boolean): void;
  className?: string;
}

export const CommentButton = ({
  setIsCommentModal,
  className,
}: CommentButtonProps) => (
  <Button
    icon={<FlagOutlined />}
    onClick={() => setIsCommentModal(true)}
    className={className}
    data-testid="note-button"
  >
    Примечание
  </Button>
);
